import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { TabBar, TabItem } from '../components';

const LandscapeEditProjectsAddProjectBasicInformationTemplate: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id, projectId } = useParams();
  return (
    <div>
      <TabBar
        onSelect={(id: string | null) => {
          if (id) {
            navigate(id);
          }
        }}
        defaultSelected={location.pathname}
      >
        <TabItem
          title="Basic information"
          id={`/landscapes/edit/${id}/projects/add-project/${projectId}/basic-information`}
        />
        <TabItem
          title="Requested Support"
          id={`/landscapes/edit/${id}/projects/add-project/${projectId}/basic-information/requested-support`}
        />
      </TabBar>
      <main>{children}</main>
    </div>
  );
};

export default LandscapeEditProjectsAddProjectBasicInformationTemplate;
